import get from 'lodash/get'
import {createSelector} from 'reselect'

import {InvalidSizeCombinationError} from '../exceptions'
import {status} from './helpers'
import Sizes, {EMPTY_SIZES} from '../types/Sizes'
import {and, notFn} from '../utils'

// Get

export const error = (state) => get(state, 'sizes.error')
export const sizes = (state) => get(state, 'sizes.data')

// Status

export const {isFailure, isPending, isSuccess} = status('sizes')

// Computed

export const hasError = createSelector(error, (e) => e instanceof Error)

export const hasInvalidSizeCombinationError = createSelector(
  error,
  (e) => e instanceof InvalidSizeCombinationError,
)

export const exist = createSelector(
  sizes,
  ($sizes) => $sizes instanceof Sizes && $sizes !== EMPTY_SIZES,
)

export const isFatal = createSelector(notFn(sizes), isFailure, and)
